import React from 'react';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import FontAwesome from 'react-fontawesome';
import ExpoSeries from './expo-series';
import './expo-list.css';

/** @class ExpoList
  * Displays a list of virtual expos available to edit
  */
export default class ExpoList extends ReactFireComponent {
  /** @constructor
    * Creates a new instance of the component.
    */
  constructor(props) {
    super(props);
    this.dataURL = '/series';
    this.state = {series: []}
  }
  /** @method componentWillMount
    * Connects the expo list to the firebase database.
    * Updates to the database will then automatically
    * update the expo list.
    */
  componentWillMount() {
    this.bindAsArray(this.dataURL, 'series');
  }
  /** @method componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount() {
    this.unbind();
  }
  /** @method
    * Renders the component
    */
  render() {
    const series = this.state.series.map((expoSeries) => (
      <ExpoSeries key={expoSeries.id} {...expoSeries}/>
    ));
    return (
      <div className="series">
        <h1>Virtual Expo Series</h1>
        {series}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/series-list/series-list.js